import React from 'react';
import { Box, useTheme } from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

interface PaymentTrendsProps {
  data: {
    month: string;
    subscriptionRevenue: number;
    tripRevenue: number;
    totalRevenue: number;
  }[];
}

const PaymentTrends: React.FC<PaymentTrendsProps> = ({ data }) => {
  const theme = useTheme();

  // Custom tooltip to format currency
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: 2,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 1,
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
          }}
        >
          <p><strong>{label}</strong></p>
          {payload.map((entry: any, index: number) => (
            <p key={`item-${index}`} style={{ color: entry.color, margin: '4px 0' }}>
              {entry.name}: ${entry.value.toFixed(2)}
            </p>
          ))}
        </Box>
      );
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', height: 350 }}>
      <ResponsiveContainer>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis
            tickFormatter={(value) => `$${value}`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Area
            type="monotone"
            dataKey="subscriptionRevenue"
            name="Subscription Revenue"
            stackId="1"
            stroke={theme.palette.info.main}
            fill={theme.palette.info.light}
          />
          <Area
            type="monotone"
            dataKey="tripRevenue"
            name="Trip Revenue"
            stackId="1"
            stroke={theme.palette.warning.main}
            fill={theme.palette.warning.light}
          />
          <Area
            type="monotone"
            dataKey="totalRevenue"
            name="Total Revenue"
            stroke={theme.palette.success.main}
            fill="none"
            strokeDasharray="5 5"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default PaymentTrends; 